<template>
  <material-card>
    <v-layout slot="header" px-3>
      <v-flex mt-2 pl-3 align-center justify-center>
        <div class="headline">Grupy</div>

        <p>Grupy do których należy klient</p>
      </v-flex>
    </v-layout>

    <v-layout row justify-center>
      <v-flex xs12 md8>
        <v-layout row justify-center>
          <v-spacer />

          <check-permission permissions="PROFILE.GROUP_MANAGE" entity-type="profile" :entity-id="profileId">
            <v-btn color="primary" @click="showGroupModal"> <v-icon left>mdi-plus</v-icon>Dodaj </v-btn>
          </check-permission>
        </v-layout>

        <v-list two-line>
          <template v-for="(group, index) in groups">
            <v-divider v-if="index > 0" :key="-1 * index" />

            <v-list-tile :key="index">
              <v-list-tile-content>
                <v-list-tile-title>{{ group.name }}</v-list-tile-title>

                <v-list-tile-sub-title>{{ group.auto | auto }}</v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action v-if="!group.auto">
                <check-permission permissions="PROFILE.GROUP_MANAGE" entity-type="profile" :entity-id="profileId">
                  <v-btn color="error" icon flat @click="confirmRemove(group.id, group.name)">
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </check-permission>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
      </v-flex>
    </v-layout>

    <material-dialog
      :id="remove.id"
      title="Potwierdź usunięcie grupy"
      cancel-text="Anuluj"
      confirm-text="Usuń grupę"
      header-color="white--text error darken-1"
      :show="confirmDialog"
      :text="`Usunięcie grupy ${remove.name} jest nieodwracalne.`"
      :width="400"
      @close="hideDialog"
      @confirm="removeGroup"
    />

    <group-modal v-if="groupModalShow" :show="groupModalShow" @close="hideGroupModal" />
  </material-card>
</template>

<script>
import { mapState } from 'vuex';

import MaterialCard from '@/components/material/Card';
import MaterialDialog from '@/components/material/Dialog';
import { notificationsMixin } from '@/mixins/notifications';
import GroupModal from '../modals/Group.modal';

// @vuese
// Wyświetlanie zakładki grup klienta
// @group Client-Profile
export default {
  components: { GroupModal, MaterialDialog, MaterialCard },
  filters: {
    auto(val) {
      return val ? 'Automatyczna' : '';
    }
  },
  mixins: [notificationsMixin],
  data() {
    return {
      text: 'Grupy',
      groupModalShow: false,
      confirmDialog: false,
      remove: {
        id: undefined,
        user: undefined
      }
    };
  },
  computed: mapState({
    groups: state => state.client.groups.list,
    profileId: state => state.client.data.profile.id
  }),
  mounted() {
    this.$store.dispatch('client/groups/list');
  },
  methods: {
    // @vuese
    // Funkcja wywołuje modal przypisania grupy
    showGroupModal() {
      this.groupModalShow = true;
    },
    // @vuese
    // Funkcja ukrywa modal przypisania grupy
    hideGroupModal() {
      this.groupModalShow = false;
    },
    // @vuese
    // Funkcja ustawia dane do potwierdzenia przy usuwaniu
    confirmRemove(id, name) {
      this.remove.id = id;
      this.remove.name = name;
      this.showDialog();
    },
    // @vuese
    // Funkcja ukrywa modal potwierdzenia usunięcia
    hideDialog() {
      this.confirmDialog = false;
      this.remove.id = undefined;
      this.remove.name = undefined;
    },
    // @vuese
    // Funkcja wywołuje modal potwierdzenia usunięcia przypisania grupy
    showDialog() {
      this.confirmDialog = true;
    },
    // @vuese
    // Funkcja wywołuje metode w store do usunięcia przypisania grupy
    // @arg `id` ID grupy do usunięcia
    async removeGroup(id) {
      try {
        await this.$store.dispatch('client/groups/remove', { profileId: this.profileId, groupId: id });
        this.notifySuccess('Pomyślnie usunięto grupę klienta');
      } catch (error) {
        this.notifyError('Niestety, nie udało się usunąć grupy');
      }
    }
  }
};
</script>
